export default __webpack_public_path__ + "static/proxima-nova-400-i-5496822368e35dfa9b22503cda3a7b0c.woff2";